module.exports = __webpack_public_path__ + "img/low hips.7a2947f7.png";